import {
  Component,
  EventEmitter,
  OnDestroy,
  OnInit,
  Output
} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs';
import { ToDoService } from '../to-do.service';
import { KycRequest } from './kyc-requests';

@Component({
  selector: 'cs-kyc-requests',
  standalone: false,
  templateUrl: './kyc-requests.component.html',
  styleUrls: ['./kyc-requests.component.scss']
})
export class KYCRequestsComponent implements OnInit, OnDestroy {
  public kycRequests: Array<KycRequest>;
  private $onDestroy = new Subject();
  public isLoading: boolean = true;

  @Output()
  public closeTodo = new EventEmitter<void>();

  constructor(private service: ToDoService, private router: Router) {}

  public ngOnDestroy(): void {
    this.$onDestroy.next(0);
    this.$onDestroy.complete();
  }

  public ngOnInit(): void {
    this.service
      .getKycRequests()
      .pipe(takeUntil(this.$onDestroy))
      .subscribe(resp => {
        this.kycRequests = resp;
        this.isLoading = false;
      });
  }

  public requestClick(request: KycRequest): void {
    this.router.navigate(['/crm/customers/kyc-documents/approval'], {
      queryParams: { documentId: request.documentId }
    });
    this.closeTodo.emit();
  }
}
